import { render, staticRenderFns } from "./MenuLeilao.vue?vue&type=template&id=f438a3ba"
import script from "./MenuLeilao.vue?vue&type=script&lang=js"
export * from "./MenuLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports